import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetDormakabaIsConnectedRequest = {
  email: string
}

type GetDormakabaIsConnectedResponse = {
  isConnected: boolean
}

export const getDormakabaIsConnectedQueryKey = (data: GetDormakabaIsConnectedRequest) => [
  'useGetDormakabaIsConnected',
  data,
]

const getDormakabaIsConnected = async (data: GetDormakabaIsConnectedRequest) => {
  const response = await authAPI.get<GetDormakabaIsConnectedResponse>('/dormakaba/isconnected', {
    params: { email: data.email },
  })
  return response.data
}

export const useGetDormakabaIsConnected = (data: GetDormakabaIsConnectedRequest) =>
  useQuery({
    enabled: Boolean(data.email),
    queryFn: () => getDormakabaIsConnected(data),
    queryKey: getDormakabaIsConnectedQueryKey(data),
    refetchOnWindowFocus: false,
    retry: false,
  })
